/**
 * Which item the Lanes inspector shows (`?i=<kind>:<id>`), so every list in the tab can mark it
 * selected (accent bar + subtle background + aria-current) in sync with the URL and keyboard.
 */
import { createContext, useContext } from 'react'

export const SelectedKeyContext = createContext<string | undefined>(undefined)

/** Is `kind:id` the inspected item (ignoring a trailing `:tab`)? */
export function useIsSelected(kind: string, id: string | undefined): boolean {
  const key = useContext(SelectedKeyContext)
  if (!key || !id) return false
  return key === `${kind}:${id}` || key.startsWith(`${kind}:${id}:`)
}

export const useSelectedKey = () => useContext(SelectedKeyContext)
